import { Component, computed, input, output } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { type CalloutType } from '../callout/callout.model';

const TOAST_ICONS: Record<CalloutType, string> = {
  success: '⚽',
  error: '🟥',
  warning: '🟨',
  info: '📣',
  tip: '🏆',
};

@Component({
  selector: 'lib-toast',
  imports: [ButtonComponent],
  styleUrls: [
    '../../tokens/colors.css',
    '../../tokens/callout-tokens.css',
    './toast.component.css',
  ],
  templateUrl: './toast.component.html',
  host: {
    '[class]': '"msa-callout msa-callout--" + type()',
    'role': 'alert',
  },
})
export class ToastComponent {
  title = input<string>();
  message = input.required<string>();
  type = input<CalloutType>('info');
  dismissible = input<boolean>(true);
  duration = input<number>(4000);

  dismissed = output<void>();

  readonly icon = computed(() => TOAST_ICONS[this.type()]);

  onDismiss(): void {
    this.dismissed.emit();
  }
}
